"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarRating = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const StarOutline_1 = __importDefault(require("@kyruus/react-ikons/StarOutline"));
const Star_1 = __importDefault(require("@kyruus/react-ikons/Star"));
const constants_1 = require("../../common/util/constants");
const utils_1 = require("../utils");
const styles_1 = require("../styles");
const STAR_SIZE = 16;
exports.StarRating = (0, intl_1.injectIntl)(({ averageRating, intl }) => {
    const ratingScale = constants_1.DEFAULTS.PROVIDER_RATING_SCALE;
    const filledPercent = `${averageRating / (0.01 * ratingScale)}%`;
    const roundedRating = averageRating.toFixed(1);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.SummaryStars, { "aria-hidden": true, "data-testid": "star-rating", ratingScale: ratingScale, size: STAR_SIZE },
            react_1.default.createElement(styles_1.StarsWrapper, null,
                react_1.default.createElement(styles_1.EmptyStars, null, (0, utils_1.iconArrayCreator)(StarOutline_1.default, ratingScale, STAR_SIZE)),
                react_1.default.createElement(styles_1.FilledStars, { filledPercent: filledPercent }, (0, utils_1.iconArrayCreator)(Star_1.default, ratingScale, STAR_SIZE)))),
        react_1.default.createElement(styles_1.AverageRating, null,
            intl.formatMessage(constants_1.messages.averageRating, {
                roundedRating
            }),
            react_1.default.createElement("span", { "aria-hidden": true }, " \u2022 "))));
});
//# sourceMappingURL=StarRating.js.map